// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__NZRJ0","header":"Messages_header__1QNx9"};